import Column from '@components/Column';
import Text from '@components/Text';
import styled from '@emotion/styled';
import useGlobalName from '@hooks/useGlobalName';
import { ItemResponse } from '@models/item';
import { useRef, useState } from 'react';
import Slider from 'react-slick';

import useNutritionExists from './hooks/useNutritionExists';
import ItemImage from './ItemImage';

interface Props {
    item: ItemResponse;
    shopId: string;
}

function ItemInfo({ item }:Props) {
    const {
        name, description, imageUrls, nameJa, nameEn,
    } = item;
    const itemName = useGlobalName({ nameEn, nameJa, name });
    const nutritionExists = useNutritionExists(item.id);
    return (
        <Container as='section' align='center'
            fullWidth
            spacing={12}>
            <ItemImage imageUrls={imageUrls}
                name={itemName}
                itemId={item.id}/>
            <BreakText size='3xl' fontWeight='bold' align='center' >
                {itemName}
            </BreakText>
            <BreakText align='center' >
                {description}
            </BreakText>
        </Container>
    );
}
const Container = styled(Column)`
    padding: 32px 20px 16px;
`;

const ImageContainer = styled.div`
    margin-bottom: 10px;
    min-width: 244px;
    padding: 0 72px;
    position: relative;
    max-width: 100%;
`;

const BreakText = styled(Text)`
    word-break: break-word;
`;

export default ItemInfo;
